import * as constants from './constants';

export const initialState = {
  loading: false,
  roles: [],
  possibleParentRoles: [],
  templateRoles: [],
  services: [],
  partnerServices: [],
  serviceRoleList: [],
  servicePartnerList: [],
  serviceUsersList: [],
  serviceUsersListData: {}, // данные, по которым в serviceUsersList находится список исполнителей
  operations: [],
  permissionItem: null, // на удаление
  permissionList: [], // на удаление
  permissionListUserId: null, // на удаление
  permissions: [],
  customerRoles: [],
  customerRolesUserId: null, // id пользователя, роли которого загружены в customerRoles
  loadingUserRoles: false,
  userRoles: [], // роли текущего залогиневшегося пользователя
  error: undefined,
  permissionsByOperation: [],
  partnerPermissionList: [], // список разрешений партнёра
  partnerPermissionListPartnerId: undefined, // ID партнёра, по которому в partnerPermissionList загружен список разрешений
  loadingPartnerPermissionList: false,
};

const permissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.FETCH_ROLES_FAIL:
    case constants.FETCH_ROLES_SUCCESS:
    case constants.CREATE_ROLE_FAIL:
    case constants.CREATE_ROLE_SUCCESS:
    case constants.UPDATE_ROLE_FAIL:
    case constants.UPDATE_ROLE_SUCCESS:
    case constants.DELETE_ROLE_FAIL:
    case constants.DELETE_ROLE_SUCCESS:
    case constants.FETCH_SERVICES_FAIL:
    case constants.FETCH_SERVICES_SUCCESS:
    case constants.CREATE_SERVICE_FAIL:
    case constants.CREATE_SERVICE_SUCCESS:
    case constants.UPDATE_SERVICE_FAIL:
    case constants.UPDATE_SERVICE_SUCCESS:
    case constants.DELETE_SERVICE_FAIL:
    case constants.DELETE_SERVICE_SUCCESS:
    case constants.FETCH_SERVICE_ROLE_FAIL:
    case constants.FETCH_SERVICE_ROLE_SUCCESS:
    case constants.CREATE_SERVICE_ROLE_FAIL:
    case constants.CREATE_SERVICE_ROLE_SUCCESS:
    case constants.DELETE_SERVICE_ROLE_FAIL:
    case constants.DELETE_SERVICE_ROLE_SUCCESS:
    case constants.FETCH_OPERATIONS_FAIL:
    case constants.FETCH_OPERATIONS_SUCCESS:
    case constants.CREATE_OPERATION_FAIL:
    case constants.CREATE_OPERATION_SUCCESS:
    case constants.UPDATE_OPERATION_FAIL:
    case constants.UPDATE_OPERATION_SUCCESS:
    case constants.DELETE_OPERATION_FAIL:
    case constants.DELETE_OPERATION_SUCCESS:
    case constants.RESET_PERMISSIONS:
    case constants.FETCH_PERMISSIONS:
    case constants.FETCH_PERMISSIONS_FAIL:
    case constants.FETCH_PERMISSIONS_SUCCESS:
    case constants.FETCH_CUSTOMER_ROLES_FAIL:
    case constants.FETCH_CUSTOMER_ROLES_SUCCESS:
    case constants.CREATE_CUSTOMER_ROLES_FAIL:
    case constants.CREATE_CUSTOMER_ROLES_SUCCESS:
    case constants.DELETE_CUSTOMER_ROLES_FAIL:
    case constants.DELETE_CUSTOMER_ROLES_SUCCESS:
    case constants.UPDATE_CUSTOMER_ROLES_REDUX:
    case constants.FETCH_SERVICE_PARTNER_FAIL:
    case constants.FETCH_SERVICE_PARTNER_SUCCESS:
    case constants.CLEAR_SERVICE_PARTNER_SUCCESS:
    case constants.CREATE_SERVICE_PARTNER_FAIL:
    case constants.CREATE_SERVICE_PARTNER_SUCCESS:
    case constants.DELETE_SERVICE_PARTNER_FAIL:
    case constants.DELETE_SERVICE_PARTNER_SUCCESS:
    case constants.FETCH_SERVICE_USERS:
    case constants.FETCH_SERVICE_USERS_FAIL:
    case constants.FETCH_SERVICE_USERS_SUCCESS:
    case constants.FETCH_USER_ROLES:
    case constants.FETCH_USER_ROLES_SUCCESS:
    case constants.FETCH_USER_ROLES_FAIL:
    case constants.RESET_USER_ROLES:
    case constants.FETCH_PARENT_ROLES_SUCCESS:
    case constants.FETCH_PARENT_ROLES_FAIL:
    case constants.FETCH_TEMPLATE_ROLES_SUCCESS:
    case constants.FETCH_TEMPLATE_ROLES_FAIL:
    case constants.RESET_PARTNER_PERMISSIONS:
    case constants.FETCH_PARTNER_PERMISSIONS:
    case constants.FETCH_PARTNER_PERMISSIONS_SUCCESS:
    case constants.POST_PARTNER_PERMISSION_SUCCESS:
    case constants.POST_PARTNER_PERMISSION_FAIL:
    case constants.CLEAR_PARTNER_PERMISSION_LIST:
      return { ...state, ...action.payload };
    case constants.FETCH_PARTNER_PERMISSIONS_FAIL:
      return { ...state, ...action.payload, partnerPermissionList: [], partnerPermissionListPartnerId: undefined };
    default:
      return state;
  }
};

export default permissionsReducer;
